export class FormationProgrammeModel {
  idFormation: number;
  objectifs: string;
  formationCertifiante: boolean;
  certification: string;
  dureeValidite?: number;
  competencesVisees: string;
  idValeurNiveauDiplomeEntree: number;
  prerequis: string;
  modalitesEtDelais: string;
  publicCible: string;
  contenu: string;
  lieu: string;
  rythmeEtPeriodes: string;
  foad: string;
  accessibleHandicapes: boolean;
  servicesAnnexes: string;
  pedagogie: string;
  modalitesEvaluation: string;
  idValeurNiveauDiplomeSortie: number;
  suiteParcours: string;
  individualisable: string;
  activitesSousTraitees: string;
  lesPlus: string;
  idCodeDiplome: number;
  idTypeQualificationVisee: number;
  codeRncp: string;
}
